// extracted by mini-css-extract-plugin
export default {"parent":"customerSearch_parent__AiGtw","child":"customerSearch_child__EseEe","hideInput":"customerSearch_hideInput__Hzj1v"};